// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__bbnzG","title":"AfterImages45_title__3ISuM","images":"AfterImages45_images__2OU_9"};